import { createSlice } from '@reduxjs/toolkit';

import { LocalizationState } from './state.interface';

const initialState: LocalizationState = {
  common: null,
  components: null,
  instances: null,
};

const localization = createSlice({
  name: 'localization',
  initialState,
  reducers: {
    setLocalization: (state, action) => {
      state.common = action.payload.common;
      state.components = action.payload.components;
      state.instances = action.payload.instances;
    },
  },
});

export const { setLocalization } = localization.actions;

export default localization;
